module.exports = __webpack_public_path__ + "img/mobprojecticon.31d0a899.svg";